// // pages/ProfilePage.jsx
// import React, { useState, useEffect, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import axios from "axios";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { CONSTANTS } from "../constants/Constants";

// const ProfilePage = () => {
//   const { currentUser, userDetails, updateUserData } = useAuth();
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState("profile");
//   const [isEditing, setIsEditing] = useState(false);
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     address: "",
//     city: "",
//     state: "",
//     pincode: "",
//     bio: "",
//     education: "",
//     preferences: {
//       notifications: false,
//       emailUpdates: false,
//     },
//   });
//   const fileInputRef = useRef(null);

//   // Redirect if not logged in
//   useEffect(() => {
//     if (!currentUser && !isLoading) {
//       navigate("/login", { replace: true });
//     }
//   }, [currentUser, navigate, isLoading]);

//   // Initialize form data from user details
//   useEffect(() => {
//     if (userDetails) {
//       setFormData({
//         firstName: userDetails.firstName || "",
//         lastName: userDetails.lastName || "",
//         email: userDetails.email || currentUser?.email || "",
//         phone: userDetails.phone || "",
//         address: userDetails.address || "",
//         city: userDetails.city || "",
//         state: userDetails.state || "",
//         pincode: userDetails.pincode || "",
//         bio: userDetails.bio || "",
//         education: userDetails.education || "",
//         preferences: {
//           notifications: userDetails.preferences?.notifications || false,
//           emailUpdates: userDetails.preferences?.emailUpdates || false,
//         },
//       });
//     }
//   }, [userDetails, currentUser]);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     if (name.startsWith("preferences.")) {
//       const preferenceName = name.split(".")[1];
//       setFormData({
//         ...formData,
//         preferences: {
//           ...formData.preferences,
//           [preferenceName]: checked,
//         },
//       });
//     } else {
//       setFormData({
//         ...formData,
//         [name]: type === "checkbox" ? checked : value,
//       });
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       setIsLoading(true);

//       // Update user data in MongoDB through the context
//       const updatedData = await updateUserData(formData);

//       toast.success("Profile updated successfully");
//       setIsEditing(false);
//     } catch (error) {
//       console.error("Error updating profile:", error);
//       toast.error("Failed to update profile: " + error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleProfilePictureChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     // Only accept image files
//     if (!file.type.startsWith("image/")) {
//       toast.error("Please select an image file");
//       return;
//     }

//     // Max file size: 5MB
//     if (file.size > 5 * 1024 * 1024) {
//       toast.error("File size must be less than 5MB");
//       return;
//     }

//     try {
//       setIsLoading(true);

//       // Create a FormData object to send the file
//       const formData = new FormData();
//       formData.append("profilePicture", file);
//       formData.append("uid", currentUser.uid);

//       // Upload the image to server

//       const response = await axios.post(
//         `${CONSTANTS.APIURL}/api/users/upload-profile-picture`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       // Update user data with new photo URL
//       await updateUserData({ photoURL: response.data.photoURL });

//       toast.success("Profile picture updated successfully");
//     } catch (error) {
//       console.error("Error uploading profile picture:", error);
//       toast.error("Failed to upload profile picture: " + error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Function to calculate profile completeness percentage
//   const calculateProfileCompleteness = () => {
//     const fields = [
//       formData.firstName,
//       formData.lastName,
//       formData.email,
//       formData.phone,
//       formData.address,
//       formData.city,
//       formData.state,
//       formData.pincode,
//       formData.bio,
//       formData.education,
//     ];

//     const filledFields = fields.filter(
//       (field) => field && field.trim() !== ""
//     ).length;
//     return Math.round((filledFields / fields.length) * 100);
//   };

//   const completenessPercentage = calculateProfileCompleteness();

//   if (!currentUser) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-100">
//         <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-gray-700"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-gray-100 min-h-screen pt-24 pb-12">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="mb-8">
//           <h1 className="text-3xl font-bold text-gray-800">My Profile</h1>
//           <p className="mt-2 text-gray-600">
//             Manage your account settings and preferences
//           </p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//           {/* Sidebar */}
//           <div className="md:col-span-1">
//             <div className="bg-white rounded-lg shadow-md overflow-hidden">
//               {/* Profile picture and name */}
//               <div className="p-6 text-center border-b border-gray-200">
//                 <div className="relative inline-block">
//                   <div className="w-32 h-32 mx-auto rounded-full overflow-hidden bg-gray-200 border-4 border-white shadow">
//                     {userDetails?.photoURL ? (
//                       <img
//                         src={userDetails.photoURL}
//                         alt={`${userDetails.firstName} ${userDetails.lastName}`}
//                         className="w-full h-full object-cover"
//                       />
//                     ) : (
//                       <div className="w-full h-full flex items-center justify-center bg-gray-700 text-white text-4xl font-semibold">
//                         {userDetails?.firstName?.charAt(0)}
//                         {userDetails?.lastName?.charAt(0)}
//                       </div>
//                     )}
//                   </div>
//                   <button
//                     onClick={() => fileInputRef.current.click()}
//                     className="absolute bottom-0 right-0 bg-gray-800 text-white rounded-full p-2 shadow-md hover:bg-gray-700 transition-colors"
//                     disabled={isLoading}
//                   >
//                     <svg
//                       className="w-4 h-4"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
//                       />
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
//                       />
//                     </svg>
//                   </button>
//                   <input
//                     type="file"
//                     ref={fileInputRef}
//                     className="hidden"
//                     onChange={handleProfilePictureChange}
//                     accept="image/*"
//                   />
//                 </div>
//                 <h2 className="mt-4 text-xl font-bold text-gray-800">
//                   {userDetails?.firstName} {userDetails?.lastName}
//                 </h2>
//                 <p className="text-gray-600">{currentUser.email}</p>
//               </div>

//               {/* Profile completeness */}
//               <div className="p-6 border-b border-gray-200">
//                 <div className="flex justify-between items-center mb-2">
//                   <span className="text-sm font-medium text-gray-700">
//                     Profile Completeness
//                   </span>
//                   <span className="text-sm font-medium text-gray-700">
//                     {completenessPercentage}%
//                   </span>
//                 </div>
//                 <div className="w-full bg-gray-200 rounded-full h-2.5">
//                   <div
//                     className="h-2.5 rounded-full"
//                     style={{
//                       width: `${completenessPercentage}%`,
//                       backgroundColor:
//                         completenessPercentage < 30
//                           ? "#ef4444"
//                           : completenessPercentage < 70
//                           ? "#f59e0b"
//                           : "#10b981",
//                     }}
//                   ></div>
//                 </div>
//                 {completenessPercentage < 100 && (
//                   <p className="mt-2 text-xs text-gray-500">
//                     Complete your profile to get the most out of our platform
//                   </p>
//                 )}
//               </div>

//               {/* Navigation */}
//               <div className="p-4">
//                 <nav className="space-y-1">
//                   <button
//                     className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md ${
//                       activeTab === "profile"
//                         ? "bg-gray-100 text-gray-900"
//                         : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
//                     }`}
//                     onClick={() => setActiveTab("profile")}
//                   >
//                     <svg
//                       className="mr-3 h-5 w-5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                       />
//                     </svg>
//                     Personal Information
//                   </button>

//                   <button
//                     className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md ${
//                       activeTab === "preferences"
//                         ? "bg-gray-100 text-gray-900"
//                         : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
//                     }`}
//                     onClick={() => setActiveTab("preferences")}
//                   >
//                     <svg
//                       className="mr-3 h-5 w-5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
//                       />
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//                       />
//                     </svg>
//                     Preferences
//                   </button>

//                   <Link
//                     to="/dashboard"
//                     className="w-full flex items-center px-3 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-gray-50 hover:text-gray-900"
//                   >
//                     <svg
//                       className="mr-3 h-5 w-5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
//                       />
//                     </svg>
//                     Dashboard
//                   </Link>

//                   <Link
//                     to="/my-courses"
//                     className="w-full flex items-center px-3 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-gray-50 hover:text-gray-900"
//                   >
//                     <svg
//                       className="mr-3 h-5 w-5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
//                       />
//                     </svg>
//                     My Courses
//                   </Link>
//                 </nav>
//               </div>
//             </div>

//             {/* Account information */}
//             <div className="mt-8 bg-white rounded-lg shadow-md overflow-hidden">
//               <div className="p-6 border-b border-gray-200">
//                 <h3 className="text-lg font-medium text-gray-800">
//                   Account Information
//                 </h3>
//               </div>
//               <div className="p-6">
//                 <div className="space-y-4">
//                   <div>
//                     <p className="text-sm font-medium text-gray-500">
//                       Account Created
//                     </p>
//                     <p className="mt-1 text-sm text-gray-800">
//                       {userDetails?.createdAt
//                         ? new Date(userDetails.createdAt).toLocaleDateString(
//                             "en-US",
//                             {
//                               year: "numeric",
//                               month: "long",
//                               day: "numeric",
//                             }
//                           )
//                         : "N/A"}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="text-sm font-medium text-gray-500">
//                       Last Login
//                     </p>
//                     <p className="mt-1 text-sm text-gray-800">
//                       {userDetails?.lastLogin
//                         ? new Date(userDetails.lastLogin).toLocaleDateString(
//                             "en-US",
//                             {
//                               year: "numeric",
//                               month: "long",
//                               day: "numeric",
//                               hour: "2-digit",
//                               minute: "2-digit",
//                             }
//                           )
//                         : "N/A"}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="text-sm font-medium text-gray-500">
//                       Email Verification
//                     </p>
//                     <p className="mt-1 text-sm flex items-center">
//                       {currentUser?.emailVerified ? (
//                         <span className="text-green-600 flex items-center">
//                           <svg
//                             className="h-4 w-4 mr-1"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth="2"
//                               d="M5 13l4 4L19 7"
//                             />
//                           </svg>
//                           Verified
//                         </span>
//                       ) : (
//                         <span className="text-yellow-600 flex items-center">
//                           <svg
//                             className="h-4 w-4 mr-1"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth="2"
//                               d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
//                             />
//                           </svg>
//                           Not verified
//                         </span>
//                       )}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Main content */}
//           <div className="md:col-span-2">
//             <div className="bg-white rounded-lg shadow-md overflow-hidden">
//               <div className="p-6 border-b border-gray-200 flex justify-between items-center">
//                 <h2 className="text-xl font-bold text-gray-800">
//                   {activeTab === "profile"
//                     ? "Personal Information"
//                     : "Preferences"}
//                 </h2>

//                 {activeTab === "profile" && (
//                   <button
//                     onClick={() => setIsEditing(!isEditing)}
//                     className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
//                     disabled={isLoading}
//                   >
//                     {isEditing ? (
//                       <>
//                         <svg
//                           className="h-4 w-4 mr-1"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth="2"
//                             d="M6 18L18 6M6 6l12 12"
//                           />
//                         </svg>
//                         Cancel
//                       </>
//                     ) : (
//                       <>
//                         <svg
//                           className="h-4 w-4 mr-1"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth="2"
//                             d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
//                           />
//                         </svg>
//                         Edit
//                       </>
//                     )}
//                   </button>
//                 )}
//               </div>

//               <div className="p-6">
//                 <form onSubmit={handleSubmit}>
//                   {activeTab === "profile" ? (
//                     // Personal Information Form
//                     <div className="space-y-6">
//                       <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
//                         <div>
//                           <label
//                             htmlFor="firstName"
//                             className="block text-sm font-medium text-gray-700"
//                           >
//                             First Name
//                           </label>
//                           <div className="mt-1">
//                             <input
//                               type="text"
//                               name="firstName"
//                               id="firstName"
//                               value={formData.firstName}
//                               onChange={handleInputChange}
//                               disabled={!isEditing || isLoading}
//                               className={`block w-full rounded-md ${
//                                 !isEditing ? "bg-gray-50" : "bg-white"
//                               } border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm`}
//                             />
//                           </div>
//                         </div>

//                         <div>
//                           <label
//                             htmlFor="lastName"
//                             className="block text-sm font-medium text-gray-700"
//                           >
//                             Last Name
//                           </label>
//                           <div className="mt-1">
//                             <input
//                               type="text"
//                               name="lastName"
//                               id="lastName"
//                               value={formData.lastName}
//                               onChange={handleInputChange}
//                               disabled={!isEditing || isLoading}
//                               className={`block w-full rounded-md ${
//                                 !isEditing ? "bg-gray-50" : "bg-white"
//                               } border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm`}
//                             />
//                           </div>
//                         </div>

//                         <div>
//                           <label
//                             htmlFor="email"
//                             className="block text-sm font-medium text-gray-700"
//                           >
//                             Email Address
//                           </label>
//                           <div className="mt-1">
//                             <input
//                               type="email"
//                               name="email"
//                               id="email"
//                               value={formData.email}
//                               disabled={true} // Email cannot be changed
//                               className="block w-full rounded-md bg-gray-50 border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
//                             />
//                             <p className="mt-1 text-xs text-gray-500">
//                               Email cannot be changed
//                             </p>
//                           </div>
//                         </div>

//                         <div>
//                           <label
//                             htmlFor="phone"
//                             className="block text-sm font-medium text-gray-700"
//                           >
//                             Phone Number
//                           </label>
//                           <div className="mt-1">
//                             <input
//                               type="tel"
//                               name="phone"
//                               id="phone"
//                               value={formData.phone}
//                               onChange={handleInputChange}
//                               disabled={!isEditing || isLoading}
//                               className={`block w-full rounded-md ${
//                                 !isEditing ? "bg-gray-50" : "bg-white"
//                               } border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm`}
//                             />
//                           </div>
//                         </div>

//                         <div className="sm:col-span-2">
//                           <label
//                             htmlFor="address"
//                             className="block text-sm font-medium text-gray-700"
//                           >
//                             Address
//                           </label>
//                           <div className="mt-1">
//                             <input
//                               type="text"
//                               name="address"
//                               id="address"
//                               value={formData.address}
//                               onChange={handleInputChange}
//                               disabled={!isEditing || isLoading}
//                               className={`block w-full rounded-md ${
//                                 !isEditing ? "bg-gray-50" : "bg-white"
//                               } border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm`}
//                             />
//                           </div>
//                         </div>

//                         <div>
//                           <label
//                             htmlFor="city"
//                             className="block text-sm font-medium text-gray-700"
//                           >
//                             City
//                           </label>
//                           <div className="mt-1">
//                             <input
//                               type="text"
//                               name="city"
//                               id="city"
//                               value={formData.city}
//                               onChange={handleInputChange}
//                               disabled={!isEditing || isLoading}
//                               className={`block w-full rounded-md ${
//                                 !isEditing ? "bg-gray-50" : "bg-white"
//                               } border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm`}
//                             />
//                           </div>
//                         </div>

//                         <div>
//                           <label
//                             htmlFor="state"
//                             className="block text-sm font-medium text-gray-700"
//                           >
//                             State
//                           </label>
//                           <div className="mt-1">
//                             <input
//                               type="text"
//                               name="state"
//                               id="state"
//                               value={formData.state}
//                               onChange={handleInputChange}
//                               disabled={!isEditing || isLoading}
//                               className={`block w-full rounded-md ${
//                                 !isEditing ? "bg-gray-50" : "bg-white"
//                               } border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm`}
//                             />
//                           </div>
//                         </div>

//                         <div>
//                           <label
//                             htmlFor="pincode"
//                             className="block text-sm font-medium text-gray-700"
//                           >
//                             PIN Code
//                           </label>
//                           <div className="mt-1">
//                             <input
//                               type="text"
//                               name="pincode"
//                               id="pincode"
//                               value={formData.pincode}
//                               onChange={handleInputChange}
//                               disabled={!isEditing || isLoading}
//                               className={`block w-full rounded-md ${
//                                 !isEditing ? "bg-gray-50" : "bg-white"
//                               } border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm`}
//                             />
//                           </div>
//                         </div>

//                         <div>
//                           <label
//                             htmlFor="education"
//                             className="block text-sm font-medium text-gray-700"
//                           >
//                             Education
//                           </label>
//                           <div className="mt-1">
//                             <input
//                               type="text"
//                               name="education"
//                               id="education"
//                               value={formData.education}
//                               onChange={handleInputChange}
//                               disabled={!isEditing || isLoading}
//                               className={`block w-full rounded-md ${
//                                 !isEditing ? "bg-gray-50" : "bg-white"
//                               } border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm`}
//                               placeholder="e.g., B.A. Political Science"
//                             />
//                           </div>
//                         </div>

//                         <div className="sm:col-span-2">
//                           <label
//                             htmlFor="bio"
//                             className="block text-sm font-medium text-gray-700"
//                           >
//                             Bio
//                           </label>
//                           <div className="mt-1">
//                             <textarea
//                               name="bio"
//                               id="bio"
//                               rows={4}
//                               value={formData.bio}
//                               onChange={handleInputChange}
//                               disabled={!isEditing || isLoading}
//                               className={`block w-full rounded-md ${
//                                 !isEditing ? "bg-gray-50" : "bg-white"
//                               } border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm`}
//                               placeholder="Tell us a bit about yourself"
//                             />
//                           </div>
//                           <p className="mt-2 text-sm text-gray-500">
//                             Brief description about yourself. This will be
//                             visible to instructors.
//                           </p>
//                         </div>
//                       </div>

//                       {isEditing && (
//                         <div className="flex justify-end mt-6">
//                           <button
//                             type="button"
//                             onClick={() => setIsEditing(false)}
//                             className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none mr-3"
//                             disabled={isLoading}
//                           >
//                             Cancel
//                           </button>
//                           <button
//                             type="submit"
//                             className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700 focus:outline-none"
//                             disabled={isLoading}
//                           >
//                             {isLoading ? (
//                               <>
//                                 <svg
//                                   className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   fill="none"
//                                   viewBox="0 0 24 24"
//                                 >
//                                   <circle
//                                     className="opacity-25"
//                                     cx="12"
//                                     cy="12"
//                                     r="10"
//                                     stroke="currentColor"
//                                     strokeWidth="4"
//                                   ></circle>
//                                   <path
//                                     className="opacity-75"
//                                     fill="currentColor"
//                                     d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                                   ></path>
//                                 </svg>
//                                 Saving...
//                               </>
//                             ) : (
//                               "Save Changes"
//                             )}
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   ) : (
//                     // Preferences Tab
//                     <div className="space-y-6">
//                       <div>
//                         <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">
//                           Notification Settings
//                         </h3>
//                         <div className="mt-4 space-y-4">
//                           <div className="flex items-start">
//                             <div className="flex items-center h-5">
//                               <input
//                                 id="notifications"
//                                 name="preferences.notifications"
//                                 type="checkbox"
//                                 checked={formData.preferences.notifications}
//                                 onChange={handleInputChange}
//                                 className="h-4 w-4 text-gray-600 focus:ring-gray-500 border-gray-300 rounded"
//                               />
//                             </div>
//                             <div className="ml-3 text-sm">
//                               <label
//                                 htmlFor="notifications"
//                                 className="font-medium text-gray-700"
//                               >
//                                 Push Notifications
//                               </label>
//                               <p className="text-gray-500">
//                                 Receive notifications about new courses,
//                                 updates, and events.
//                               </p>
//                             </div>
//                           </div>

//                           <div className="flex items-start">
//                             <div className="flex items-center h-5">
//                               <input
//                                 id="emailUpdates"
//                                 name="preferences.emailUpdates"
//                                 type="checkbox"
//                                 checked={formData.preferences.emailUpdates}
//                                 onChange={handleInputChange}
//                                 className="h-4 w-4 text-gray-600 focus:ring-gray-500 border-gray-300 rounded"
//                               />
//                             </div>
//                             <div className="ml-3 text-sm">
//                               <label
//                                 htmlFor="emailUpdates"
//                                 className="font-medium text-gray-700"
//                               >
//                                 Email Updates
//                               </label>
//                               <p className="text-gray-500">
//                                 Receive email updates about your courses,
//                                 assignments, and important announcements.
//                               </p>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       <div className="pt-5 border-t border-gray-200">
//                         <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4">
//                           Privacy Settings
//                         </h3>
//                         <p className="text-sm text-gray-500 mb-4">
//                           Control how your information is displayed and shared
//                           on our platform.
//                         </p>

//                         {/* Privacy settings options would go here */}
//                         <div className="text-sm text-gray-500 italic">
//                           Enhanced privacy settings coming soon.
//                         </div>
//                       </div>

//                       <div className="flex justify-end pt-5 border-t border-gray-200">
//                         <button
//                           type="submit"
//                           className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700 focus:outline-none"
//                           disabled={isLoading}
//                         >
//                           {isLoading ? (
//                             <>
//                               <svg
//                                 className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 fill="none"
//                                 viewBox="0 0 24 24"
//                               >
//                                 <circle
//                                   className="opacity-25"
//                                   cx="12"
//                                   cy="12"
//                                   r="10"
//                                   stroke="currentColor"
//                                   strokeWidth="4"
//                                 ></circle>
//                                 <path
//                                   className="opacity-75"
//                                   fill="currentColor"
//                                   d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                                 ></path>
//                               </svg>
//                               Saving...
//                             </>
//                           ) : (
//                             "Save Preferences"
//                           )}
//                         </button>
//                       </div>
//                     </div>
//                   )}
//                 </form>
//               </div>
//             </div>

//             {/* Additional section: Learning History */}
//             <div className="mt-8 bg-white rounded-lg shadow-md overflow-hidden">
//               <div className="p-6 border-b border-gray-200">
//                 <h2 className="text-xl font-bold text-gray-800">
//                   Learning History
//                 </h2>
//               </div>
//               <div className="p-6">
//                 <div className="bg-gray-50 p-4 rounded-lg text-center">
//                   <svg
//                     className="mx-auto h-12 w-12 text-gray-400"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth="2"
//                       d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
//                     />
//                   </svg>
//                   <h3 className="mt-2 text-sm font-medium text-gray-900">
//                     No courses completed yet
//                   </h3>
//                   <p className="mt-1 text-sm text-gray-500">
//                     Start learning to build your learning history.
//                   </p>
//                   <div className="mt-6">
//                     <Link
//                       to="/classroom"
//                       className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700 focus:outline-none"
//                     >
//                       Explore Courses
//                       <svg
//                         className="ml-2 -mr-1 h-4 w-4"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth="2"
//                           d="M9 5l7 7-7 7"
//                         />
//                       </svg>
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Account Security Section */}
//             <div className="mt-8 bg-white rounded-lg shadow-md overflow-hidden">
//               <div className="p-6 border-b border-gray-200">
//                 <h2 className="text-xl font-bold text-gray-800">
//                   Account Security
//                 </h2>
//               </div>
//               <div className="p-6">
//                 <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-2">
//                   <div>
//                     <h3 className="text-md font-medium text-gray-700">
//                       Password
//                     </h3>
//                     <p className="mt-1 text-sm text-gray-500">
//                       Last changed:{" "}
//                       {userDetails?.passwordLastChanged
//                         ? new Date(
//                             userDetails.passwordLastChanged
//                           ).toLocaleDateString()
//                         : "Never"}
//                     </p>
//                     <div className="mt-4">
//                       <Link
//                         to="/change-password"
//                         className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
//                       >
//                         <svg
//                           className="h-4 w-4 mr-1"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth="2"
//                             d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
//                           />
//                         </svg>
//                         Change Password
//                       </Link>
//                     </div>
//                   </div>

//                   <div>
//                     <h3 className="text-md font-medium text-gray-700">
//                       Two-Factor Authentication
//                     </h3>
//                     <p className="mt-1 text-sm text-gray-500">
//                       Add an extra layer of security to your account.
//                     </p>
//                     <div className="mt-4">
//                       <Link
//                         to="/setup-2fa"
//                         className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
//                       >
//                         <svg
//                           className="h-4 w-4 mr-1"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth="2"
//                             d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
//                           />
//                         </svg>
//                         Setup 2FA
//                         <span className="ml-1 px-1.5 py-0.5 text-xs font-medium rounded-full bg-gray-100 text-gray-800">
//                           Coming Soon
//                         </span>
//                       </Link>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="mt-8 pt-6 border-t border-gray-200">
//                   <h3 className="text-md font-medium text-gray-700">
//                     Session Management
//                   </h3>
//                   <p className="mt-1 text-sm text-gray-500">
//                     Manage your active sessions and sign out from other devices.
//                   </p>
//                   <div className="mt-4">
//                     <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
//                       <svg
//                         className="h-4 w-4 mr-1"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth="2"
//                           d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
//                         />
//                       </svg>
//                       Sign Out from All Devices
//                       <span className="ml-1 px-1.5 py-0.5 text-xs font-medium rounded-full bg-gray-100 text-gray-800">
//                         Coming Soon
//                       </span>
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;
// pages/ProfilePage.jsx
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useEnrollment } from "../context/EnrollmentContext";
import { toast } from "react-toastify";

const ProfilePage = () => {
  const { currentUser, userDetails, updateUserData, signOut } = useAuth();
  const { activeEnrollments, loading: enrollmentLoading } = useEnrollment();
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    education: "",
  });

  // Redirect if not logged in
  useEffect(() => {
    if (!currentUser) {
      navigate("/login", { replace: true });
    }
  }, [currentUser, navigate]);

  // Initialize form data
  useEffect(() => {
    if (userDetails) {
      console.log("User Details:", userDetails);
      setFormData({
        firstName: userDetails.firstName || "",
        lastName: userDetails.lastName || "",
        phone: userDetails.phone || "",
        address: userDetails.address || "",
        city: userDetails.city || "",
        state: userDetails.state || "",
        education: userDetails.education || "",
      });
    }
  }, [userDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      await updateUserData(formData);
      toast.success("Profile updated successfully");
      setIsEditing(false);
    } catch (error) {
      toast.error("Failed to update profile");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate("/");
    } catch (error) {
      toast.error("Failed to sign out");
    }
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (!currentUser) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center text-white text-xl font-bold">
                {userDetails?.firstName?.charAt(0) || currentUser?.email?.charAt(0)}
                {userDetails?.lastName?.charAt(0) || ""}
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">
                  {userDetails?.firstName} {userDetails?.lastName}
                </h1>
                <p className="text-gray-600">{currentUser.email}</p>
              </div>
            </div>
            <button
              onClick={handleSignOut}
              className="px-4 py-2 text-sm text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors"
            >
              Sign Out
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Profile Information */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg shadow-sm p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-semibold text-gray-900">Profile Information</h2>
                <button
                  onClick={() => setIsEditing(!isEditing)}
                  className="px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                >
                  {isEditing ? "Cancel" : "Edit"}
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      First Name
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      disabled={!isEditing}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        !isEditing ? "bg-gray-50" : ""
                      }`}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Last Name
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      disabled={!isEditing}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        !isEditing ? "bg-gray-50" : ""
                      }`}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      value={currentUser.email}
                      disabled
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      disabled={!isEditing}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        !isEditing ? "bg-gray-50" : ""
                      }`}
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Address
                    </label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      disabled={!isEditing}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        !isEditing ? "bg-gray-50" : ""
                      }`}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      City
                    </label>
                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      disabled={!isEditing}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        !isEditing ? "bg-gray-50" : ""
                      }`}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      State
                    </label>
                    <input
                      type="text"
                      name="state"
                      value={formData.state}
                      onChange={handleInputChange}
                      disabled={!isEditing}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        !isEditing ? "bg-gray-50" : ""
                      }`}
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Education
                    </label>
                    <input
                      type="text"
                      name="education"
                      value={formData.education}
                      onChange={handleInputChange}
                      disabled={!isEditing}
                      placeholder="e.g., 10th Standard, B.A. Political Science"
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                        !isEditing ? "bg-gray-50" : ""
                      }`}
                    />
                  </div>
                </div>

                {isEditing && (
                  <div className="flex justify-end space-x-3 pt-4">
                    <button
                      type="button"
                      onClick={() => setIsEditing(false)}
                      className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="px-4 py-2 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50"
                    >
                      {isLoading ? "Saving..." : "Save Changes"}
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Account Status */}
            <div className="bg-white rounded-lg shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Account Status</h3>
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-sm text-gray-600">Member Since</span>
                  <span className="text-sm font-medium">
                    {formatDate(userDetails?.createdAt)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-gray-600">Active Courses</span>
                  <span className="text-sm font-medium text-green-600">
                    {activeEnrollments.length}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-gray-600">Email Status</span>
                  <span className={`text-sm font-medium ${
                    currentUser.emailVerified ? "text-green-600" : "text-yellow-600"
                  }`}>
                    {currentUser.emailVerified ? "Verified" : "Pending"}
                  </span>
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="bg-white rounded-lg shadow-sm p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
              <div className="space-y-2">
                <Link
                  to="/dashboard"
                  className="block w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 rounded-lg"
                >
                  📊 Dashboard
                </Link>
                <Link
                  to="/classroom"
                  className="block w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 rounded-lg"
                >
                  📚 Browse Courses
                </Link>
                {/* <Link
                  to="/online-classes"
                  className="block w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 rounded-lg"
                >
                  🎥 Online Classes
                </Link> */}
              </div>
            </div>
          </div>
        </div>

        {/* Enrolled Courses */}
        <div className="mt-6 bg-white rounded-lg shadow-sm p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">My Enrolled Courses</h2>
          
          {enrollmentLoading ? (
            <div className="text-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
              <p className="mt-2 text-gray-600">Loading your courses...</p>
            </div>
          ) : activeEnrollments.length === 0 ? (
            <div className="text-center py-8">
              <div className="text-gray-400 text-6xl mb-4">📚</div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">No Courses Yet</h3>
              <p className="text-gray-600 mb-4">Start your learning journey by enrolling in a course</p>
              <Link
                to="/classroom"
                className="inline-flex items-center px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                Browse Courses
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {activeEnrollments.map((enrollment) => (
                <div key={enrollment.courseId} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="font-medium text-gray-900 text-sm leading-tight">
                      {enrollment.courseName}
                    </h3>
                    <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800">
                      Active
                    </span>
                  </div>
                  <div className="space-y-1 text-xs text-gray-600">
                    <p>Language: {enrollment.language}</p>
                    <p>Expires: {formatDate(enrollment.expiryDate)}</p>
                  </div>
                  <div className="mt-3 flex space-x-2">
                    <Link
                      to="/dashboard"
                      className="flex-1 text-center px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                      Continue
                    </Link>
                    <Link
                      to="/online-classes"
                      className="flex-1 text-center px-3 py-1 text-xs border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
                    >
                      Classes
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;